import { useEffect, useState } from 'preact/hooks'
import HashTable from '~/components/Hash'
import { login, test } from '~/services'
import SecondaryPage from './projects/templates/SecondaryPageTemplate'
import AdvancedHash from '~/components/AdvancedHash'
import Terminal from '~/components/Terminal'

function Crypt() {
	const [text, setText] = useState<string>('beneath stars at night two lovers walk')
	const [salt, setSalt] = useState<number>(0)

	useEffect(() => {
		console.log('cool')
		login('emerkel', 'password123')
		test()
	}, [])

	return (
		<SecondaryPage>
			<div className="flex flex-col items-center">
				<label htmlFor="password" className="">
					Somewhere far away
					<br />
					In a garden with high walls
					<br />
					You will not find me
				</label>
				<input type="password" id="password" onChange={(e) => setText(e.currentTarget.value)} />
				<input type="number" max={Number.MAX_SAFE_INTEGER} min={Number.MIN_SAFE_INTEGER} value={salt} onChange={(e) => setSalt(Number(e.currentTarget.value))} />
				<HashTable text={text} salt={salt} />
				{/* <AdvancedHash text={text} /> */}
			</div>
		</SecondaryPage>
	)
}

export default Crypt
